<template>
  <div>
    <h2>Please, update to iOS11.</h2>
  </div>
</template>

<script>
export default {
  name: 'Update',
  created() {
    if (!this.$store.state.isMobile
      || !this.$store.state.isSafari
      || !this.$store.state.iOSversion > 10) {
      this.$router.push({ name: 'Slider' })
    }
  },
}
</script>

<style lang="scss" scoped>

div {
  position: fixed;
  height: 100%;
  width: 100%;
  background: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  h2 {
    width: 60%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Update.vue